import React from "react";
import { Button } from "@mui/material"; 
import "./SetupOriginsWarning.css";
import { icons } from "../../svg";

interface SetupOriginsWarningProps {
  onGoBack: () => void;
  onSetupOrigins: () => void;
}

const SetupOriginsWarning: React.FC<SetupOriginsWarningProps> = ({
  onGoBack,
  onSetupOrigins,
}) => {
  return (
    <div className="prompt-overlay">
      <div className="prompt-panel">
        <header className="prompt-header">
          <h2>Setup Favorite Origins for Selected Product</h2>
        </header>
        <main className="prompt-body">
          <img
            data-tooltip-id="exclamation-mark-with-circle"
            src={icons.ExclamationMarkWithCircle}
            alt="exclamation-mark-with-circle"
          />
          <p className="prompt-main-text">
            The product you selected has no favorite origins set up.
          </p>
          <p className="prompt-sub-text">
            To quote using this product, please add favorite origins.
          </p>
        </main>
        <footer className="prompt-footer">
          <Button
            variant="outlined"
            className="prompt-button go-back-btn"
            onClick={onGoBack}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            className="prompt-button setup-btn"
            onClick={onSetupOrigins}
          >
            Setup Origins
          </Button>
        </footer>
      </div>
    </div>
  );
};

export default SetupOriginsWarning;
